(() => {
  if (window.MayLondonCatalog) return;
  const config = JSON.parse(document.getElementById('MayLondonConfig')?.textContent || '{}');
  const i18n = window.MayLondonI18n;
  const snapshots = new Map();
  let verifiedRecent = [];
  const validHandle = handle => typeof handle === 'string' && /^[-\p{L}\p{N}\p{M}\u2122\u00ae]+$/u.test(handle);
  const escape = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const icons = item => {
    const keys = ['spring', 'summer', 'autumn', 'winter'].filter(key => item.seasons?.includes(key) && config.seasons?.[key]);
    if (!keys.length) return '';
    const names = keys.map(key => config.seasons[key].label).join(', ');
    return `<span class="product-season-icons" role="group" aria-label="${escape(config.seasonLabel)}: ${escape(names)}" title="${escape(names)}">${keys.slice(0, 2).map(key => {
      const season = config.seasons[key];
      return `<img class="product-season-icon" data-season-icon="${key}" src="${escape(season.image)}" alt="${escape(season.label)}" title="${escape(season.label)}" width="24" height="24" decoding="async">`;
    }).join('')}</span>`;
  };
  const snapshot = handle => {
    if (!validHandle(handle)) return Promise.resolve(null);
    if (!snapshots.has(handle)) snapshots.set(handle, (async () => {
      try {
        const url = i18n.route('products/' + encodeURIComponent(handle)) + '?section_id=product-summary';
        const response = await fetch(url, { headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(8000) });
        if (!response.ok) throw new Error('Unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const item = JSON.parse(document.querySelector('[data-product-summary]')?.textContent || 'null');
        if (!item || item.handle !== handle || item.hidden !== false || typeof item.title !== 'string') return null;
        return item;
      } catch (_) { snapshots.delete(handle); return null; }
    })());
    return snapshots.get(handle);
  };
  const recent = async (limit = 6, exclude = '') => {
    let items = [];
    try { const saved = JSON.parse(localStorage.getItem('mayLondonRecentlyViewed') || '[]'); if (Array.isArray(saved)) items = saved; } catch (_) {}
    const handles = [...new Set(items.map(item => item?.handle).filter(validHandle))].filter(handle => handle !== exclude).slice(0, limit);
    verifiedRecent = (await Promise.all(handles.map(snapshot))).filter(Boolean);
    return verifiedRecent;
  };
  window.MayLondonCatalog = { snapshot, recent, icons, cachedRecent: () => verifiedRecent };
})();
